var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('center',[_c('h6',[_vm._v("Confirm")])]),_c('h5',{staticClass:"info-text"},[_vm._v("Review the information you have provided.")]),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-10 mt-3"},[_c('ul',{domProps:{"innerHTML":_vm._s(_vm.formatWizardModel())}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }